import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronRight } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: BreadcrumbItem[];
  backPath?: string;
  action?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  breadcrumbs,
  backPath,
  action,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="mb-6">
      {/* パンくずリスト */}
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className="mb-3">
          <ol className="flex items-center gap-1 text-sm">
            {breadcrumbs.map((item, index) => {
              const isLast = index === breadcrumbs.length - 1;
              return (
                <React.Fragment key={index}>
                  {index > 0 && (
                    <span className="text-text-secondary">
                      <ChevronRight size={18} />
                    </span>
                  )}
                  {isLast ? (
                    <span className="font-medium text-text-primary">{item.label}</span>
                  ) : (
                    <button
                      onClick={() => item.path && navigate(item.path)}
                      className="text-text-secondary hover:text-primary hover:underline transition-colors"
                    >
                      {item.label}
                    </button>
                  )}
                </React.Fragment>
              );
            })}
          </ol>
        </nav>
      )}

      {/* タイトル行 */}
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-2">
          {backPath !== undefined && (
            <button
              onClick={handleBack}
              title="戻る"
              className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-gray-100 text-text-secondary transition-colors"
            >
              <ArrowLeft size={18} />
            </button>
          )}
          <div>
            <h1 className="text-2xl font-bold text-text-primary">{title}</h1>
            {subtitle && (
              <p className="text-sm text-text-secondary mt-0.5">{subtitle}</p>
            )}
          </div>
        </div>

        {action && <div>{action}</div>}
      </div>
    </div>
  );
};
